export const SAVE_ALL_FINANCIAL_SUBCATEGORIES = 'SAVE_ALL_FINANCIAL_SUBCATEGORIES'